
import React from "react";
import UserCard from "./UserCard";
import EmptyUserList from "./EmptyUserList";
import LoadingState from "./LoadingState";

interface FollowersListProps {
  followers?: any[];
  loading: boolean;
}

const FollowersList = ({ followers, loading }: FollowersListProps) => {
  if (loading) {
    return <LoadingState />;
  }

  if (!followers || followers.length === 0) {
    return <EmptyUserList message="No followers yet" />;
  }

  return (
    <div className="space-y-4">
      {followers.map((follower) => (
        <UserCard 
          key={follower.id}
          id={follower.id}
          avatarUrl={follower.avatar_url}
          fullName={follower.full_name}
          username={follower.username}
        />
      ))}
    </div>
  );
};

export default FollowersList;
